import { Box, Button, Grid } from "@mui/material";
import { styled } from "@mui/styles";
import Navbar from "../../components/navbar";
import MainFrame from "../../components/mainFrame";
import TextContainer from "../../components/Texts/TextContainer";
import { CustomTextField } from "../../components/TextFields";
import * as yup from "yup"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import PhoneNumberInput from "../../components/inputs/phoneNumberInput";
import PassWordInput from "../../components/inputs/passwordInput";
import {  smallButton } from "../../components/Button";
import { Helmet } from "react-helmet";

const Container = styled(Box)({
    width: "100%",
    padding: "1rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    minHeight: "90vh",
    maxHeight: "90vh"
})
const Form = styled(Grid)({
    padding: "1rem",
    width: "100%",
    maxHeight: "80vh",
    overflow: "auto",
    height: "fit-content"
})
const schema = yup.object().shape({
    username: yup.string().required('نام کاربری الزامی است.'),
    name: yup.string().required('نام الزامی است.'),
    email: yup.string().required('ایمیل الزامی است.'),
    phone: yup.string().required('شماره همراه الزامی است.'),
    currentPassword: yup.string().required('رمز عبور فعلی الزامی است.'),
    newPassword: yup.string().required(' رمزعبور جدید الزامی است.'),
})
function ProfileSettings() {
    const {
        setValue,
        // handleSubmit,
        formState: { errors },
        watch,
    } = useForm({
        resolver: yupResolver(schema),
    });
    return (
        <Container bgcolor="primary.light">
            <Helmet>
                <title> پروفایل کاربر | پنل ادمین yaadin</title>
            </Helmet>
            <Navbar title="پروفایل کاربر" />
            <TextContainer
                color="divider"
                width="100%"
                justifyContent="right">
                شما در بخش پنل مدیریت هستید. مهم است که رمز عبور خود را ایمن نگه دارید. هرگز رمز عبور را در دستگاهی که متعلق به شما نیست ذخیره نکنید.
            </TextContainer>&nbsp;
            <Form container rowGap={1} columnGap={2}>
                <Grid item xs={12} sm={5.8} md={5.8} lg={5.8} xl={5.8}>
                    <CustomTextField
                        label="نام کاربری"
                        placeholder="نام کاربری را وارد کنید."
                        required
                        variant="outlined"
                        value={watch("username")}
                        helperText={errors.username?.message}
                        error={!!errors.username}
                        onChange={(e) => setValue("username", e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={5.8} md={5.8} lg={5.8} xl={5.8}>
                    <CustomTextField
                        label="نام"
                        placeholder="نام را وارد کنید."
                        required
                        variant="outlined"
                        value={watch("name")}
                        helperText={errors.name?.message}
                        error={!!errors.name}
                        onChange={(e) => setValue("name", e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={5.8} md={5.8} lg={5.8} xl={5.8}>
                    <CustomTextField
                        label="ایمیل"
                        placeholder="ایمیل را وارد کنید."
                        required
                        variant="outlined"
                        value={watch("email")}
                        helperText={errors.email?.message}
                        error={!!errors.email}
                        onChange={(e) => setValue("email", e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={5.8} md={5.8} lg={5.8} xl={5.8}>
                    <PhoneNumberInput
                        label="شماره تماس"
                        required
                        value={watch("phone")}
                        helperText={errors.phone?.message}
                        error={!!errors.phone}
                        handleChange={(e) => setValue("phone", e)} />
                </Grid>
                <Grid item xs={12} sm={5.8} md={5.8} lg={5.8} xl={5.8}>
                    <PassWordInput
                        label="رمزعبور فعلی"
                        required
                        helperText={errors.currentPassword?.message}
                        error={!!errors.currentPassword}
                        onChange={(e) => setValue("currentPassword", e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={5.8} md={5.8} lg={5.8} xl={5.8}>
                    <PassWordInput
                        label="رمزعبورجدید"
                        required
                        helperText={errors.newPassword?.message}
                        error={!!errors.newPassword}
                        onChange={(e) => setValue("newPassword", e.target.value)} />
                </Grid>
            </Form>
            <Button variant="contained" sx={[smallButton, { bgcolor: "customColors.purple" }]}>
                بروزرسانی
            </Button>
        </Container>
    )
}
export default MainFrame(ProfileSettings)